/**
 * Enum defining available booster variants for different teams/products
 */
export enum BoosterVariant {
  /** Reward Platform team variant (default) */
  REWARD_PLATFORM = "reward-platform",
  /** Default fallback variant */
  DEFAULT = "default",
}
